/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect } from 'react';
import { MemoryRouter as Router } from 'react-router-dom';

const LoginOverlay = ({ onClose }) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const currentUrl = window.location.href;
      console.log('>>>url saved stored in sessionStorage : ', currentUrl);
      sessionStorage.setItem('loginOverlayReturnUrl', currentUrl);
    }
  }, []);

  const handleOverlayDismiss = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleLoginFlowComplete = () => {
    console.log('>>>at handleLoginFlowComplete ');
    if (typeof window !== 'undefined') {
      const savedUrl = sessionStorage.getItem('loginOverlayReturnUrl');
      console.log('>>>get url saved stored in sessionStorage : ', savedUrl);
      if (savedUrl) {
        sessionStorage.removeItem('loginOverlayReturnUrl');
        console.log(
          '>>>remove url saved stored in sessionStorage : ',
          savedUrl
        );
        window.history.replaceState({}, '', savedUrl);
        console.log('>>>reload the page : ', savedUrl);
        window.location.reload();
      }
    }
  };

  // Dynamic import to avoid SSR issues with MMT-UI
  let ExternalOverlay: any = null;
  if (typeof window !== 'undefined') {
    try {
      const mmtUI = require('MMT-UI/mobileLogin/Overlay');
      ExternalOverlay = mmtUI.ExternalOverlay;
    } catch (error) {
      console.warn('Failed to load MMT-UI ExternalOverlay:', error);
    }
  }
  // Return null during SSR or if ExternalOverlay is not available
  if (!ExternalOverlay) {
    return null;
  }

  return (
    <Router>
      <div className="overlay__bg">
        <ExternalOverlay
          showSocialLoginOverlay={false}
          hideOverlay={true}
          loginRoute={'https://www.makemytrip.com/login'}
          pageName=""
          bottomSheetLoginOverlayPageName=""
          showOverlay={true}
          platformSource={
            typeof window !== 'undefined' ? window.location.href : ''
          }
          hideBg={false}
          bottomSheetSkip={true}
          experiment={{}}
          onLogin={() => {}}
          onLoginFlowComplete={handleLoginFlowComplete}
          countryCode="+91"
          langData={{
            'active.offers.text': 'Active Offers',
            'app.download.expanded.strip.ctaText': 'Install App',
            'app.download.expanded.strip.header': 'Get app exclusive offers'
          }}
          onOverlayDismiss={handleOverlayDismiss}
          vendor={false}
          persuation=""
          nameCode="IN"
        />
      </div>
    </Router>
  );
};

export default LoginOverlay;
